<template>
    <v-container fluid>
        <h2 class="text-h5 mb-8">{{ $t("risk-aversion.end-page.title") }}</h2>
        <v-row justify="center">
            <v-spacer />
            <v-col class="text-center">
                <v-icon color="success" class="mb-8" size="128"> mdi-check-circle-outline </v-icon>
            </v-col>
            <v-spacer />
        </v-row>
        <p>
            {{ $t("risk-aversion.end-page.congratulations") }}
        </p>
        <p>
            {{ $t("risk-aversion.end-page.can-invest") }}
        </p>
        <p>
            {{ $t("risk-aversion.end-page.contact-us") }}
        </p>
    </v-container>
</template>

<script>
export default {
    name: "EndPage",
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped></style>
